import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class EmailassessmenteResolver implements Resolve<any> {
  constructor(private cookieService: CookieService,
              private localStorageService: LocalStorageService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    // this.cookieService.deleteAll();
    // this.localStorageService.deleteAllLocalStorage();
    return null;
  }
}
